module.exports = __webpack_public_path__ + "static/media/Sharp-Technology-MIP-Simple-Interface-4.f83450ce.png";